import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { PROJECT_API } from "../../services/apiCalls/projectApiCalls";
import { COMMON_API } from "../../services/apiCalls/commonApi";
export default function ProjectHandoverForm({ onCancel }) {
  const location = useLocation();
  const state = location.state || {};
  const [projectHandover, setProjectHandover] = useState('');
  const [selectedFile, setSelectedFile] = useState(false);
  const [projectId, setProjctID] = useState(state.project_id);
  const [projectName, setProjectName] = useState(state.Project_Name);
  const [description, setDescription] = useState('');
  const [attachment, setAttachemnt] = useState('');
  const [fileUrl, setFileUrl] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    } else {
      console.warn("No file selected.");
    }
  };

  const handleDocumentSubmit = async () => {
    const user = localStorage.getItem("state");
    const state = JSON.parse(user);

    const validateFields = () => {
      if (!projectId || projectName === "" || description === "" || selectedFile === false) {
        toast.error("Please fill in all fields!");
        return false;
      }
      return true;
    };

    const resetFields = () => {
      setProjctID("");
      setProjectName("");
      setDescription("");
      setFileUrl("");
      setSelectedFile("");
    };

    const saveDocumentFile = async () => {
      if (selectedFile) {
        const allowedType = "application/pdf";
        if (selectedFile.type !== allowedType) {
          toast.error("Only PDF files are allowed!");
          return null;
        }

        const responseFile = await PROJECT_API.saveDocument(selectedFile);
        if (responseFile.fileUrl) {
          setFileUrl(responseFile.fileUrl);
          return responseFile.fileUrl;
        }
      }
      return fileUrl;
    };

    if (!validateFields()) return;

    try {
      const fileUrlToUse = selectedFile ? await saveDocumentFile() : fileUrl;

      if (fileUrlToUse === null) {
        return;
      }

      const payload = {
        ProjectID: projectId,
        ProjectName: projectName,
        Description: description,
        Attachment: fileUrlToUse,
        CreatedBy: state.user.user_id,
      };

      const apiMethod = COMMON_API.createProjectHandover;

      const response = await apiMethod(payload);

      if (response && (response.status === 200 || response.status === 201)) {
        toast.success("Document created successfully!");
        resetFields();

        // Notify parent to switch to the "Project Handover List" tab
        onCancel();
      } else {
        toast.error(response?.error || "An error occurred.");
      }
    } catch (error) {
      console.error("Error submitting document:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <>
      <div className="mt-2">
        <div className="d-flex">
          <div className="d-flex flex-column" style={{ marginLeft: "30px" }}>
            <label className="input-label" htmlFor="projectName">
              Project Name
            </label>
            <input
              disabled
              className="input-style"
              type="text"
              name="projectName"
              id="projectName"
              placeholder="Enter Project Name"
              value={state.Project_Name}
            />
          </div>
          <div className="d-flex flex-column" style={{ marginLeft: "30px" }}>
            <label className="input-label" htmlFor="description">
              Description
            </label>
            <input
              className="input-style"
              type="text"
              name="description"
              id="description"
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              placeholder="Enter Description"
              autoComplete="off"
            />
          </div>
          <div className="d-flex flex-column" style={{ marginLeft: "30px" }}>
            <label className="input-label" htmlFor="attachment">
              Attachment
            </label>
            <input
              className="input-style"
              type="file"
              name="attachment"
              id="attachment"
              accept="application/pdf"
              onChange={handleFileChange}
            />
          </div>
        </div>
        <div className="action-div">
          <div className="button-div">
            <button
              className="btn btn-submit"
              onClick={handleDocumentSubmit}
            >
              Submit
            </button>
            <button
              className="btn btn-cancel"
              onClick={onCancel} // Trigger parent tab change
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

